
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2 18v-5h3.2v1h1.6v-1h6.4v1h1.6v-1H18v5H2zM2 8c0-.55.157-1.021.47-1.413C2.783 6.196 3.16 6 3.6 6H6V4c0-.55.157-1.02.47-1.412C6.783 2.196 7.16 2 7.6 2h4.8c.44 0 .817.196 1.13.588.314.391.47.862.47 1.412v2h2.4c.44 0 .817.196 1.13.587.313.392.47.863.47 1.413v4h-3.2v-2h-1.6v2H6.8v-2H5.2v2H2V8zm5.6-2h4.8V4H7.6v2z","fill":"#94A3B8"}})])
          )
        }
      }
    